import React from "react";

const HistoryQCTableRow = ({
  record,
  ...antdProps
}) => {
  if (!record) {
    return <tr {...antdProps} />; // eslint-disable-line react/jsx-props-no-spreading
  }

  return (
    <tr {...antdProps} /> // eslint-disable-line
  );
};

export default HistoryQCTableRow;
